// src/pages/docs/game/dice.jsx
import { Typography, Box, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const DiceCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            /주사위
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}<br />{"다른 플레이어와 함께 즐길 수 있습니다."}
          </Typography>
          <Typography variant="h6">
            {"사용법: /주사위 <코인, 하프, 올인>"}<br />{"<>는 필수 사항입니다."}
          </Typography>
          {/*<Typography variant="h6">
            {"동일명령어: ?가위바위보, ?ㄱㅇ, ?ㅂㅇ, ?ㅂ"}
          </Typography>*/}
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /주사위 5000, /주사위 ㅎㅍ, /주사위 ㅇㅇ"}<br /><br />{"<혼자하기>: 승리 시 배팅금액의 2배, 비길 시 배팅금액의 절반을 획득합니다."}<br />{"<참여하기>: 승리 시 수수료 5%를 제외한 배팅금액의 2배, 비길 시 수수료 5%를 제외한 배팅금액을 돌려받습니다."}
          </Typography>
        </Box>

        {/* 오른쪽 이미지 + 버튼 묶음 */}
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: {xs:'center', md:'flex-start'},
          gap: 2,
          textAlign: { xs: 'center', md: 'left' },
          width: {xs:'100%',md:'auto'},
          maxWidth: {xs:'100%',md:'auto'},
        }}>
          {/* 이미지 */}
          <Box
            component="img"
            src="/commands/dice.png"
            alt="설명 이미지"
            sx={{
              width: '100%',
              maxWidth: 400,
              borderRadius: 2,
              flexShrink: 0,
              mx: 'auto',
            }}
          />

          {/* 버튼들 */}
          {/* 바깥쪽 박스: 가운데 정렬용 (block + auto) */}
          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'center' }, gap: 5, width: '100%', mt: 1 }}>
            {prev && (
              <Button href={prev.path} variant="outlined" sx={{ mr:{xs:0},height: 36, width: 118 }}>
                ← {prev.name}
              </Button>
            )}
            {next && (
              <Button href={next.path} variant="outlined" sx={{ height: 36, width: 118 }}>
                {next.name} →
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default DiceCommand;
